import { useRef, useState } from 'react';
import './CancelOrder.scss';

const CancelOrder = ({onCancel, onClose}) => {

    const textareaRef = useRef(null);
    const [error, setError] = useState("");
    const [value, setValue] = useState("");
    const cancelClick = (e) => {
        if (!Boolean(textareaRef.current.value)) {
            setError("Required");
        } else{
            onCancel?.(textareaRef.current.value);
            onClose(e);
        }
    }

    return (
        <div className='cancel-order-component'>
            <div className='header'>
                <i className='icon-error'></i>
                <b>Please provide a reason for rejecting this order:</b>
            </div>
            <span className='label'>Rejection Reason</span>
            <textarea className={error ? 'errortxt': '' } onInput={(e) => {setValue(e.target.value);setError(Boolean(e.target.value) ? "": "Required")}} ref={textareaRef} placeholder='Please provide a brief explanation for rejecting this order'></textarea>
            <i className='error'>{error}</i>
            <div className='actions'>
                <button disabled={!Boolean(value)} className='filled greenButton' onClick={(e)=>cancelClick(e)}>Send</button>
                <button className='filled danger' onClick={onClose}>Cancel</button>
            </div>
        </div>
    )
}
export default CancelOrder;